<template>
    <div class="pdf-profile-header-container">
        <div class="flex-container">
            <div id="profileInformationDiv" class="profile-info">
                <div class="pdf-stat-label">PATIENT {{ viewingAsSuper ? 'ID' : 'NAME' }}</div>
                <div style="display: flex; align-items: flex-end">
                    <div class="pdf-section-title" style="margin: 0; flex: 1">
                        {{ !viewingAsSuper ? profileInfo.firstName + ' ' + profileInfo.lastName : profileInfo.id }}
                    </div>
                </div>

                <!--        <div class="pdf-stat-label">BASIC INFORMATION</div>-->
                <div v-if="!viewingAsSuper">
                    <div class="pdf-info-row">
                        <span v-for="(stat, index) in basicInformationRow1" :key="index" style="margin-top: 5px">
                            <span class="pdf-profile-header-with-additional-data-stat-label">{{ stat.label }}:</span>
                            <span class="pdf-stat-value">{{ stat.value ? stat.value : profile.data[stat.name] }}</span>
                        </span>

                        <span v-for="(stat, index) in medicalInformationRow1" :key="index" style="margin-top: 5px">
                          <span class="pdf-profile-header-with-additional-data-stat-label">{{ stat.label }}</span>
                          <span class="pdf-stat-value">{{ stat.value ? stat.value : profile.data[stat.name] }}</span>
                        </span>
                        <span v-for="(stat, index) in educationInformation" :key="index" style="margin-top: 5px">
                          <span class="pdf-profile-header-with-additional-data-stat-label">{{ stat.label }}:</span>
                          <span class="pdf-stat-value">{{ stat.value ? stat.value : profile.data[stat.name] }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="enableQrCode" id="qrCodeDiv" class="qr-code">
                <div v-if="goToAppProfileUrl" class="qr-code-container elevate">
                    <qrcode-vue :size="qrCodeSize" :value="goToAppProfileUrl" background="transparent" foreground="#000000"
                                level="L"/>
                </div>
                <div>
                    Profile ID
                </div>
                <div>{{ profileInfo.id }}</div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.flex-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
}

.profile-info {
    flex: 1;
}

.qr-code {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-transform: none;
    color: #8E9195;
}
</style>

<script>
import moment from "moment";
import QrcodeVue from "qrcode.vue";


export default {
    name: "ProfileHeaderWithAdditionalData",
    components: {
        QrcodeVue
    },
    props: {
        profile: {
            type: Object,
            required: true
        },
        profileTest: {
            required: true
        },
        stats: {
            required: true
        },
        completedOnDate: {
            required: true
        },
        viewingAsSuper: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            qrCodeSize: 150,
            enableQrCode: true
            // viewingAsSuper: false
        }
    },
    computed: {
        goToAppProfileUrl() {
            //if current URL has 'dev' in it, then url should be "https://devportal.swaymedical.com/gotoapp/gotoprofile?profileId=" + this.profileInfo.id
            //else url should be "https://portal.swaymedical.com/gotoapp/gotoprofile?profileId=" + this.profileInfo.id
            if (window.location.origin.includes('dev')) {
                return `https://devportal.swaymedical.com/gotoapp/gotoprofile?profileId=${this.profileInfo.id}&isQrCode=true&firstName=${this.profileInfo.firstName}&lastName=${this.profileInfo.lastName}`;
            } else {
                return `https://portal.swaymedical.com/gotoapp/gotoprofile?profileId=${this.profileInfo.id}&isQrCode=true&firstName=${this.profileInfo.firstName}&lastName=${this.profileInfo.lastName}`;
            }
        },
        profileInfo() {
            return this.profile.data.profile;
        },
        basicInformationRow1() {
            return [
                {
                    label: 'DOB',
                    value: this.profileInfo.displayBirthdate
                },
                {
                    label: 'Age',
                    value: this.profileInfo.age
                },
                {
                    label: 'Height',
                    value: this.profileInfo.displayHeight
                },
                {
                    label: 'Weight',
                    value: this.profileInfo.displayWeight
                },
                {
                    label: 'Sex',
                    value: this.profileInfo.gender
                },
                {
                    label: 'Gender',
                    value: this.profileInfo.additionalData.genderIdentityDisplay
                },
                {
                    label: 'Race',
                    value: this.profileInfo.additionalData.raceDisplay
                },
            ]
        },

        medicalInformationRow1() {
            return [
                {
                    label: 'History of concussion?',
                    value: this.profileInfo.additionalData.hasHadConcussionDisplay
                },
                {
                    label: 'Approximate date of last concussion?',
                    value: this.profileInfo.additionalData.lastConcussionDateDisplay
                },
                {
                    label: 'Diagnosed with ADD or ADHD?',
                    value: this.profileInfo.additionalData.hasAttentionDisorderDisplay
                },
            ];
        },

        educationInformation() {
            return [
                {
                    label: 'Primary Language',
                    value: this.profileInfo.additionalData.primaryLanguageDisplay
                },
                {
                    label: 'Secondary Language',
                    value: this.profileInfo.additionalData.secondaryLanguageDisplay
                },
            ];


        },

    },

}
</script>
